// extracted by mini-css-extract-plugin
export default {"PhotoTitleEditForm__submitBtn":"iy_a bia_ss","PhotoTitleEditForm__cancelBtn":"iy_b bia_sw bia_sv"};